import { render, staticRenderFns } from "./dialogo.vue?vue&type=template&id=4058d743"
import script from "./dialogo.vue?vue&type=script&lang=js"
export * from "./dialogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports